import { APP_CONFIG } from "@config/app.config";
import { Box, Stack, StackProps, Typography } from "@mui/material";


export const BorderedBlock = ({ children, header, ...props }: { children: React.ReactNode, header?: React.ReactNode } & StackProps) => {

    return (
        <Stack direction="column" spacing={1} >
            {header && (typeof header === 'string' ? (
                <Typography variant="subtitle2" color="text.primary">{header}</Typography>
            ) : (
                header
            ))}

            <Stack
                {...props}
                sx={{
                    p: 2,
                    border: 1,
                    borderColor: APP_CONFIG.ui.theme.colors.border,
                    borderRadius: 1,
                    backgroundColor: APP_CONFIG.ui.theme.colors.background,
                    ...props.sx
                }}
            >

                {children}
            </Stack>
        </Stack>
    )
}